export const addressConstants = {
	SEND_ADDRESS_REQUEST: "SEND_ADDRESS_REQUEST",
	SEND_ADDRESS_SUCCESS: "SEND_ADDRESS_SUCCESS",
	SEND_ADDRESS_ERROR: "SEND_ADDRESS_ERROR",
};
